export default __webpack_public_path__ + "static/media/29_thumbnail.920514f1.JPG";